import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SearchBar from "./components/SearchBar";
import React, { Component } from "react";
import Home from "./components/Home";
import Media, { Movie, Person } from "./components/Media";
import { Route } from "react-router-dom";
import TvShow from "./components/Media/TvShow/TvShow";

class App extends Component {
  render() {
    return (
      <div className="w-full h-1 bg-blue-dark">
        <div className="container mx-auto p-4">
          <Navbar />
          <SearchBar />

          <Route path="/" exact component={Home} />
          <Route path="/movie/:id" component={Media(Movie)} />
          <Route path="/person/:id" component={Media(Person)} />
          <Route path="/tv/:id" component={Media(TvShow)} />
        </div>

        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js